export default "__VITE_ASSET__DYXB53li__"